<div class="mobile-catalog" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
    <div class="backdrop" (click)="close()"></div>
    <div class="drawer">
        <div class="drawer-content">
            <div class="drawer-header">
                <a [routerLink]="['/']" class="logo-link" (click)="close()">
                    <img [src]="logoSrc" class="logo" alt="Company Logo" />
                </a>
                <button class="close-btn" (click)="close()">
                    <div class="pi pi-times"></div>
                </button>
            </div>

            @if ((collectionTree$ | async); as tree) {
                <ul class="collection-list">
                    @for (collection of tree.children; track $index) {
                        <li>
                            <a class="level0" (click)="onL0Click($event, collection)">{{ collection.name }}</a>
                            @if (collection.children.length) {
                                <ul [class.hidden]="selected0 !== collection.id">
                                    @for (level1 of collection.children; track $index) {
                                        <li>
                                            <a class="level1" (click)="onL1Click($event, level1)">{{ level1.name }}</a>
                                            @if (level1.children.length) {
                                                <ul class="level2-list" [class.expanded]="selected1 === level1.id">
                                                    @for (level2 of level1.children; track $index) {
                                                        <li>
                                                            <a (click)="close()" [routerLink]="['/category', level2.slug ]">{{ level2.name }}</a>
                                                        </li>
                                                    }
                                                </ul>
                                            }
                                        </li>
                                    }
                                </ul>
                            }
                        </li>
                    }
                </ul>
            }
        </div>
    </div>
</div>

